import {z} from '@hono/zod-openapi';

const variantSchema = z.object({
  eurotaxCode: z.number().int().safe().positive().openapi({example: 142591}),
  label: z.string().openapi({example: 'xDrive40i M Sport'}),
  validFrom: z.string().date().nullable(),
  fuelType: z.string().nullable(),
  engineVolume: z.number().int().nullable().openapi({description: 'Engine volume in cm³'}),
  powerKw: z.number().int().nullable(),
  transmission: z.string().nullable(),
  bodyStyle: z.string().nullable(),
  drive: z.string().nullable(),
  price: z.number().nullable().openapi({description: 'PKOL catalogue price in PLN'}),
});

export const automarketplEurotaxVariantsResponseSchema = z
  .object({
    result: z.enum(['mapped', 'missing', 'ambiguous']),
    reasonCode: z.string().openapi({
      example: 'default_base_trim',
      description: '`manual_selection` when the stored `kodEurotax` choice is used',
    }),
    blockingDimension: z
      .enum([
        'make',
        'model',
        'registrationDate',
        'fuel',
        'hybrid',
        'engineVolume',
        'power',
        'transmission',
        'bodyStyle',
        'drive',
        'generation',
        'version',
        'trim',
      ])
      .nullable()
      .openapi({
        example: 'registrationDate',
        description: 'The vehicle dimension that stops the Eurotax lookup, or null',
      }),
    selectedEurotaxCode: z.number().int().safe().positive().nullable(),
    variants: z.array(variantSchema).openapi({
      description: 'Technically eligible PKOL variants; a manual choice must be one of them',
    }),
  })
  .openapi('AutomarketplEurotaxVariantsResponse');

export type AutomarketplEurotaxVariantsResponse = z.infer<
  typeof automarketplEurotaxVariantsResponseSchema
>;
